import { useRef } from "react";

import { debounce } from "@/utils/debounce";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useDebounce = <T extends (...args: any[]) => any>(fn: T, delay: number) => {
  const ref = useRef(debounce(fn, delay));

  return ref.current;
};

export { useDebounce };
